<template>
  <div class="etg-pagination flex flex-col justify-center">
    <slot name="text">
      <p class="text mb-0 text-center text-sm text-gray-80">
        {{ $t('general.pagination', { start: startIndex, end: endIndex, total: totalCount }) }}
      </p>
    </slot>
    <n-pagination
      v-model:page="pageIndex"
      class="flex justify-center leading-20px mt-3"
      :page-slot="props.visible"
      :page-size="props.pageSize"
      :item-count="props.totalCount"
      v-bind="$attrs"
    >
      <template #prev>
        <svg-icon name="arrow-left" class="w-4 h-4" />
      </template>
      <template #next>
        <svg-icon name="arrow-right" class="w-4 h-4" />
      </template>
    </n-pagination>
  </div>
</template>

<script setup lang="ts">
import { NPagination } from 'naive-ui'

interface Props {
  count?: number
  visible?: number
  totalCount?: number
  pageSize?: number
}

const pageIndex = defineModel<number>('page', { default: 1 })

const props = withDefaults(defineProps<Props>(), {
  count: 0,
  visible: 7,
  totalCount: 200,
  pageSize: 1,
})

// const pageCount = computed(() => props.count ?? Math.ceil(props.totalCount / props.pageSize))

const startIndex = computed(() => (pageIndex.value - 1) * props.pageSize + 1)

const endIndex = computed(() => {
  const endIndex = pageIndex.value * props.pageSize
  return endIndex > props.totalCount ? props.totalCount : endIndex
})
</script>

<style lang="scss" scoped>
.etg-pagination {
  :deep(.n-pagination) {
    .n-pagination-item {
      .svg-icon {
        @apply text-black-50 transition-colors;
      }
      &:hover {
        .svg-icon {
          @apply text-white;
        }
      }
      &.n-pagination-item--active {
        @apply rounded-full;
      }
      &.n-pagination-item--disabled {
        .svg-icon {
          @apply text-gray-60;
        }
      }
    }
  }
}
</style>
